window.addEventListener("load", function () {
  var date = new Date();
  var hour = date.getHours();
  var day = 5 < hour && hour < 19;
  document.getElementById("img1").src = day
    ? new URL("img/023.jpg", import.meta.url)
    : new URL("img/028.jpg", import.meta.url);
  document.getElementById("img2").src = day
    ? new URL("img/009.jpg", import.meta.url)
    : new URL("img/035.jpg", import.meta.url);
});
